export enum LanguagesEnum {
  EN = 'en',
  FR = 'fr',
}

export const DEFAULT_LANGUAGE = LanguagesEnum.EN;
